import {Box} from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import {donutColor} from '../../../utils/utils';
import {t} from 'i18next';
import {BUDGET_CONSUMPTON_PERCENTAGE} from '../../../constants/constants';

HighchartsAccessibility(Highcharts);

interface ICustomPieChart {
  fieldName1?: string;
  fieldName2?: string;
  percentageValue: number;
  backgroundColor: string;
  customClassDonutContainer?: string;
  height?: number;
  width?: number;
}

const AurDonutchart = (props: ICustomPieChart) => {
  const {
    fieldName1,
    fieldName2,
    percentageValue,
    backgroundColor,
    height = 150,
    width = 150,
    customClassDonutContainer,
  } = props;

  if (typeof percentageValue !== 'number') {
    return null;
  }
  const percentage = Number(
    (percentageValue * BUDGET_CONSUMPTON_PERCENTAGE).toFixed(1) || 0
  );

  const color = donutColor(percentage);

  function getSubtitle() {
    if (
      fieldName1 &&
      fieldName2 &&
      fieldName1.trim() !== '' &&
      fieldName2.trim() !== ''
    ) {
      return `<span class="typo-text label3_size" style="display:flex;justifyContent:center;color: #FCFCFD;">
              ${fieldName1} 
            </span>
            <span class="typo-text label3_size" style="display:flex;justifyContent:center;color: #FCFCFD">
              ${fieldName2} 
            </span>
            <span class="typo-text display3_size" style="color: ${color}; display: flex;justifyContent:center;marginTop:8">
               ${typeof percentage === 'number' ? percentage : null}%
            </span>       
            `;
    } else {
      return `<span class="typo-text subhead2_size" style="color: ${color};">
              ${percentage}%
            </span>`;
    }
  }

  const options = {
    chart: {
      type: 'pie',
      backgroundColor: backgroundColor,
      height: height,
      width: width,
      spacing: [0, 0, 0, 0],
    },
    accessibility: {
      enabled: false,
      description: `${percentageValue}%`,
    },
    plotOptions: {
      pie: {
        innerSize: '65%',
        borderWidth: 0,
        slicedOffset: 0,
        borderColor: '#182231',

        states: {
          hover: {
            enabled: false,
          },
        },
        enableMouseTracking: false,
        dataLabels: {
          enabled: false,
        },
      },
    },
    title: false,
    subtitle: {
      useHTML: true,
      text: getSubtitle(),
      floating: true,
      verticalAlign: 'middle',
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    series: [
      {
        name: fieldName1,
        data: [
          {
            name: 'Filled',
            y: percentage,
            color: color,
          },
          {
            name: 'Empty',
            y: 100 - percentage,
            color: '#3c456B',
          },
        ],
        colorByPoint: false,
      },
    ],
  };

  return (
    <Box
      className={customClassDonutContainer}
      tabIndex={0}
      aria-label={`${t('common.estimatedBudgetUsed')} ${percentage}%`}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default AurDonutchart;
